/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials';
import {
    instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSON,
} from './FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials';

/**
 * @type FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials
 * 
 * @export
 */
export type FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials = FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials;

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials(json)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSON(json: any): any {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials(value)) {
        return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSON(value as FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials);
    }

    return {};
}

